import React, { useState } from "react";
import {
  Typography,
  Grid,
  Paper,
  IconButton,
  Divider,
} from "@material-ui/core";
import useStyles from "../styles";
import { Close } from "@material-ui/icons";
import Modal from "@mui/material/Modal";
import { LoadingOutlined } from "@ant-design/icons";
import { DomainAddOutlined } from "@mui/icons-material";
import ChooseSocietyDropDown from "../../../../../GlobalComponents/DropDowns/ChooseSocietyDropDown";

function AddSocietyModal(props) {
  const classes = useStyles();
  const {
    addSocietyModal,
    endApiCall,
    loader,
    society,
    setSociety,
    errorMessage,
    handleAddSocietyRequest
  } = props;

  return (
    <Modal open={addSocietyModal}>
      <Paper
        className={classes.ModalView}
        style={{
          backgroundColor: "#e6e7f0",
          boxShadow: "2px 2px 8px #000",
          borderRadius: 7,
          overflow: "auto",
          minWidth: "300px",
          maxWidth: "29vw",
        }}
      >
        <Grid
          container
          style={{ textAlign: "center", justifyContent: "space-between" }}
        >
          <Typography
            style={{
              fontWeight: "normal",
              color: "#000",
              fontWeight: 400,
              fontFamily: "Montserrat, sans-serif",
              textAlign: "center",
              marginLeft: 10,
              fontSize: 17,
              opacity: 1,
            }}
          >
            Add Society Request
          </Typography>
          {!loader && (
            <IconButton
              onClick={() => {
                endApiCall();
              }}
            >
              <Close style={{ color: "#000", fontSize: 20, marginTop: -10 }} />
            </IconButton>
          )}
        </Grid>
        <Divider
          style={{ marginTop: 0, marginBottom: 10, backgroundColor: "#000" }}
        />
        <Grid>
          <ChooseSocietyDropDown society={society} setSociety={setSociety} />
        </Grid>
        {errorMessage && (
          <Typography
            style={{
              textAlign: "center",
              color: "red",
              fontWeight: "bold",
              marginTop: 10,
              fontSize: "12px",
            }}
          >
            {errorMessage}
          </Typography>
        )}
        <Grid container style={{ justifyContent: "center" }}>
          <div
            class="card"
            style={{
              height: 30,
              boxShadow: "0 3px 6px #4a6078",
              width: "140px",
              backgroundColor:
                society === "Choose Society" ? "#7D858D" : "#2f45c5",
              color: "#ffffff",
              cursor: "pointer",
              marginTop: 10,
            }}
            onClick={() => {
              if (!loader) {
                handleAddSocietyRequest();
              } else {
              }
            }}
          >
            <div class="card-body ">
              <p
                class="card-text"
                style={{
                  fontSize: "11px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat, sans-serif",
                  marginTop: "-12px",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                {loader ? (
                  <LoadingOutlined
                    style={{
                      marginRight: 10,
                      fontSize: "15px",
                    }}
                  />
                ) : (
                  <DomainAddOutlined
                    style={{
                      marginRight: 10,
                      fontSize: "15px",
                    }}
                  />
                )}

                {!loader ? `Add Request` : `Adding...`}
              </p>
            </div>
          </div>
        </Grid>
      </Paper>
    </Modal>
  );
}

export default AddSocietyModal;
